import { createSelector } from 'reselect';
import APPLICATION_NAMES from 'ui-forms-editor-automation-lib/constants/APPLICATION_NAMES';
import getDynoGuid from './dynoSelectors/getDynoGuid';
import getFormGuid from './formsSelectors/getFormGuid';
import getApplicationName from './parentApplication/getApplicationName';
const getGuid = createSelector([getApplicationName, getFormGuid, getDynoGuid], (applicationName, formGuid, dynoGuid) => {
  switch (applicationName) {
    case APPLICATION_NAMES.LEADFLOWSUI:
      return dynoGuid;
    case APPLICATION_NAMES.FORMSUI:
    default:
      return formGuid;
  }
});
export default getGuid;